<div id="loader">
    <div id="spinner">
        <df-spinner size="xl" color="primary" ariaLabel="Loading" />
    </div>
</div>
